"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _lodash = /*#__PURE__*/ _interop_require_default(require("lodash"));
var _fp = require("lodash/fp");
var _definitions = /*#__PURE__*/ _interop_require_default(require("../../../../definitions"));
var _getoffertypes = /*#__PURE__*/ _interop_require_default(require("../../helpers/get-offer-types"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Returns object of all rewards that return true to the passed in function.
var buildGetAllRewards = function(methodName) {
    return function(offer, scenario) {
        var offerTypeIds = (0, _getoffertypes.default)(offer);
        var allRewards = {};
        (0, _fp.forEach)(function(offerTypeId) {
            var rewards = (0, _lodash.default)(_definitions.default).chain().get("".concat(offerTypeId, ".rewards"))// TODO: [AP-1244] Potentially a bug. This rejects any offer that doesn't have a `methodName` function.
            // e.g. methodName is undefined, return all rewards (currently correct).
            // e.g methodName is `isEligible`, if I have a reward without an `isEligible` function, it will be rejected.
            // Should the default be to return a reward as eligible if it doesn't have the function i.e. no conditions?
            .filter(function(reward) {
                return (0, _fp.isUndefined)(methodName) ? true : _lodash.default.invoke(reward, methodName, scenario);
            }).map('id').value();
            if (!(0, _fp.isEmpty)(rewards)) {
                allRewards[offerTypeId] = rewards;
            }
        }, offerTypeIds);
        return allRewards;
    };
};
var _default = buildGetAllRewards;
